import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "forgot-password" };
const _hoisted_2 = {
    key: 0,
    class: "error"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[5] || (_cache[5] = _createElementVNode("img", {
            src: "/logo.png",
            alt: "Logo",
            class: "logo"
        }, null, -1)),
        _cache[6] || (_cache[6] = _createElementVNode("h1", null, "CLIENT PORTAL", -1)),
        _createElementVNode("form", {
            onSubmit: _cache[1] || (_cache[1] = _withModifiers(
            //@ts-ignore
            (...args) => (_ctx.handleLogin && _ctx.handleLogin(...args)), ["prevent"]))
        }, [
            _createElementVNode("div", null, [
                _cache[2] || (_cache[2] = _createElementVNode("label", {
                    class: "email",
                    for: "email"
                }, "Username or Email Address:", -1)),
                _withDirectives(_createElementVNode("input", {
                    class: "input",
                    type: "email",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.email) = $event)),
                    required: ""
                }, null, 512), [
                    [_vModelText, _ctx.email]
                ])
            ]),
            _cache[3] || (_cache[3] = _createElementVNode("button", {
                class: "button",
                type: "submit"
            }, "Get New Password", -1)),
            (_ctx.errorMessage)
                ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.errorMessage), 1))
                : _createCommentVNode("", true),
            _cache[4] || (_cache[4] = _createElementVNode("p", { class: "login-text" }, [
                _createElementVNode("a", { href: "/" }, "Log In")
            ], -1))
        ], 32)
    ]));
}
